module.exports = __webpack_public_path__ + "static/media/woman.c2f359a3.svg";